import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import MetaTags from 'react-meta-tags';
import ContentContainerDefault from '~/components/ContentContainer/Default';
import { Heading2 } from '~/components/Typography/index';
import { Loading } from '~/components';
import { useGetWidgetSettingsQuery } from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import ErrorScreen from '~/scenes/ErrorScreen';
import MasterDetail from '~/components/MasterDetail';
import TEST_ID_MASTER_DETAIL from '~/components/MasterDetail/index.testid';
import Tokens from './components/Tokens';
import useApp from '~/hooks/useApp';
import groupNameToAnchorId from '~/components/SelectableAccordion/utils/groupNameToAnchorId';

type Props = RouteComponentProps & {};

export const text = {
  appTitle: 'Trustoo',
};

const MAX_CONTAINER_WIDTH = '1400px';
const Trustoo: React.FC<Props> = () => {
  const account = useCurrentAccount();
  const { data, loading } = useGetWidgetSettingsQuery({
    variables: {
      accountId: account.id,
    },
  });

  const { app } = useApp('AppStatus_Trustoo');

  const trustooAppsInWidget = data?.getWidgetSettings?.appsConfiguration.find(
    app => app.type === 'AP_AppStatus_Trustoo',
  );
  const trustooWidgetAppsId = trustooAppsInWidget?.category;

  const pathToWidget = trustooWidgetAppsId
    ? `settings/widget#${groupNameToAnchorId(trustooWidgetAppsId)}`
    : 'settings/widget';

  if (loading) return <Loading />;
  if (!data || !app?.appStatus.enabled) {
    return <ErrorScreen />;
  }

  return (
    <ContentContainerDefault
      maxContentWidth={MAX_CONTAINER_WIDTH}
      breadcrumbs={[
        {
          to: '/-/apps',
          label: 'Apps',
        },
        { label: text.appTitle },
      ]}
    >
      <MetaTags>
        <title>{text.appTitle}</title>
      </MetaTags>
      <Heading2 color={{ group: 'primary' }} margin={[null, null, 'xl', null]}>
        {text.appTitle}
      </Heading2>
      <MasterDetail
        basePath={'/-/'}
        dataTestId={TEST_ID_MASTER_DETAIL.CONTAINER}
        navbar={[
          {
            type: 'link',
            to: 'apps/trustoo',
            icon: 'incomingLink',
            name: 'Koppeling',
          },
          {
            type: 'link',
            to: pathToWidget,
            icon: 'externalLink',
            name: 'Dienstverleners in de widget',
          },
        ]}
      >
        <React.Component path={pathToWidget} />
        <Tokens path="/" default />
      </MasterDetail>
    </ContentContainerDefault>
  );
};

export default Trustoo;
